import { Injectable } from '@angular/core';
import { DateHelper } from '../helpers/dateHelper';
import { MonitorowaniePodmiotuForm } from '../models/monitorowanie-podmiotu-form.model';
import { NewUpdateSubskrypcjaContext } from '../models/new-update-subskrypcja-context.model';
import { NewUpdateSubskrypcja } from '../models/new-update-subskrypcja.model';
import { SubskrypcjaContext } from '../models/subskrypcja-context.model';
import { SubskrypcjaNaglowek } from '../models/subskrypcja-naglowek.model';
import { WszystkieSubskrypcje, WszystkieSubskrypcjeTabela } from '../models/wszystkie-subskrypcje.model';
import { KrsEntryService } from './krs-entry.service';

@Injectable({
  providedIn: 'root'
})
export class FormMapService {

  constructor(private krsEntryService: KrsEntryService) { }

  mapSubskrypcja(daneSubskrypcji: NewUpdateSubskrypcja, numerKrs: string): NewUpdateSubskrypcjaContext {
    const naglowek: SubskrypcjaNaglowek = {systemId: this.krsEntryService.normalizeKRS(numerKrs), system: 'KRS' as const};
    const subskrypcja: NewUpdateSubskrypcja = {
      subskrypcjaOd: DateHelper.formatDate(daneSubskrypcji.subskrypcjaOd, DateHelper.FORMAT_DATE),
      subskrypcjaDo: DateHelper.formatDate(daneSubskrypcji.subskrypcjaDo, DateHelper.FORMAT_DATE),
      powiadomienieEmail: daneSubskrypcji.powiadomienieEmail,
      nazwaPodmiotuSub: daneSubskrypcji.nazwaPodmiotuSub
    };
    return {naglowek, subskrypcja} as NewUpdateSubskrypcjaContext;
  }

  mapNaglowek(numerKrs: string) {
    return {systemId: this.krsEntryService.normalizeKRS(numerKrs), system: 'KRS' as const} as SubskrypcjaNaglowek;
  }

  mapSubskrypcjeTabela(wszystkieSubskrypcje: WszystkieSubskrypcje[]): WszystkieSubskrypcjeTabela[] {
    const mappedSubskrypcje = wszystkieSubskrypcje.map(val => {
      val.subskrypcja.subskrypcjaOd = DateHelper.formatDate(DateHelper.normalizeDateYYYYMMDD(val.subskrypcja.subskrypcjaOd), DateHelper.FORMAT_DATE);
      val.subskrypcja.subskrypcjaDo = DateHelper.formatDate(DateHelper.normalizeDateYYYYMMDD(val.subskrypcja.subskrypcjaDo), DateHelper.FORMAT_DATE);
      val.subskrypcja.ostatnieZdarzenie = val.subskrypcja.ostatnieZdarzenie ? DateHelper.formatDate(DateHelper.normalizeDateYYYYMMDD(val.subskrypcja.ostatnieZdarzenie), DateHelper.FORMAT_DATE) : null;
      val.subskrypcja.noweZdarzenia?.sort((a, b) => new Date(b.dataZdarzenia).getTime() - new Date(a.dataZdarzenia).getTime());
      return {
        ...val.naglowek,
        ...val.subskrypcja
      };
    });
    return mappedSubskrypcje;
  }

  mapSubskrypcjaDane(subskrypcja: SubskrypcjaContext): MonitorowaniePodmiotuForm {
    const mappedSubskrypcja = {
      subskrypcjaOd:  DateHelper.formatDate(DateHelper.normalizeDateYYYYMMDD(subskrypcja.subskrypcja.subskrypcjaOd), DateHelper.FORMAT_DATE),
      subskrypcjaDo:  DateHelper.formatDate(DateHelper.normalizeDateYYYYMMDD(subskrypcja.subskrypcja.subskrypcjaDo), DateHelper.FORMAT_DATE),
      powiadomienieEmail: subskrypcja.subskrypcja.powiadomienieEmail,
      nazwaPodmiotuSub: subskrypcja.subskrypcja.nazwaPodmiotuSub
    } as NewUpdateSubskrypcja
    return mappedSubskrypcja;
  }
}
